'use client';

import { usePathname } from 'next/navigation';

import { supportEmail } from '@/lib/config';
import { trackClick } from '@/lib/event_tracker';

import { ensureImmutable } from '@/lib/data/utils';

export default function SupportEmailLink({ sessionOrSessionData }) {
  const pathname = usePathname();
  const session = ensureImmutable(sessionOrSessionData);

  return (
    <a
      href={`mailto:${supportEmail}`}
      target="_blank"
      rel="noreferrer"
      className="font-semibold text-sky-500"
      onClick={(_e) =>
        trackClick(session, pathname, 'Contact Email Link', {
          button: 'left',
        })
      }
      onMouseDown={(e) => {
        if (e.button !== 1) {
          return;
        }

        trackClick(session, pathname, 'Contact Email Link', {
          button: 'middle',
        });
      }}
      onContextMenu={(_e) =>
        trackClick(session, pathname, 'Contact Email Link', {
          button: 'right',
        })
      }
    >
      {supportEmail}
    </a>
  );
}
